module.exports = __webpack_public_path__ + "static/media/story-22.c0788621.jpg";